<template>
    <div class="infinite-scroll-container" ref="scrollContainer" @scroll="handleScroll">
        <slot></slot>

        <div v-if="loading" class="loading-indicator">Chargement en cours...</div>

        <!-- <div v-if="allDataLoaded" class="end-of-list">Fin de la liste</div> -->
    </div>
</template>

<script>

export default {
    name: "InfiniteScrollContainer",
    props: {
        // Le callback qui sera appelé pour charger plus de données
        // Doit être une fonction qui retourne une Promesse (ou est async)
        onLoadMore: {
            type: Function,
            required: true,
        },
        // La distance avant la fin pour déclencher le chargement (en %)
        threshold: {
            type: Number,
            default: 50,
        },
    },
    data() {
        return {
            loading: false,
            allDataLoaded: false,
        };
    },
    mounted() {
        this.checkScroll();
    },
    methods: {
        handleScroll: _.debounce(function () {
            this.checkScroll();
        }, 100),

        checkScroll() {
            const container = this.$refs.scrollContainer;

            if (!container || this.loading || this.allDataLoaded) {
                return;
            }

            // 1. Détection du scroll
            // Condition 1: Nous avons dépassé le seuil de scroll (en pourcent de la taille total à scroller)
            const currentPosition = (container.scrollTop * 100) / (container.scrollHeight - container.clientHeight)
            const thresholdExceeded = currentPosition > this.threshold;

            // Condition 2: Le contenu n'a pas rempli le conteneur visible (initialement ou après chargement)
            const notEnoughContent = container.scrollHeight <= container.clientHeight;

            const shouldLoad = thresholdExceeded || notEnoughContent;

            if (shouldLoad) {
                this.loadData();
            }
        },

        async loadData() {
            
            if (this.loading || this.allDataLoaded) {
                return;
            }
            
            this.loading = true;

            if (typeof this.onLoadMore !== 'function') {
                console.warn("onLoadMore n'est pas une fonction ou n'est pas définie.");
                this.allDataLoaded = true;
                return; 
            }

            try {
                // Appelle la prop/callback fournie par le parent
                // Le callback est responsable de récupérer les données ET de les ajouter à la liste du parent
                this.onLoadMore().then(hasMore => {
                    
                    if (hasMore === false) {
                        // Si 'false', il n'y a plus de données
                        this.allDataLoaded = true;
                    }

                    this.loading = false;
                });

            } catch (error) {
                console.error("Erreur lors du chargement des données :", error);
                this.loading = false;
            }
        },
    },
};
</script>

<style scoped>
.infinite-scroll-container {
    height: 100%;
    overflow-y: auto;
    border: 1px solid #ccc;
    padding: 10px;
}

.loading-indicator,
.end-of-list {
    text-align: center;
    padding: 10px;
    font-weight: bold;
    color: #007bff;
}
</style>
